import React from 'react';
import { useApp } from '../AppContext';

interface ServiceData {
  title: string;
  price: string;
  text: string;
  icon: React.ReactNode;
  delay: string;
}

const services: ServiceData[] = [
  {
    title: 'Terapia Individuale',
    price: '€60 · 45 min',
    text: 'La ricerca di un nuovo senso degli eventi della vita: aumentare consapevolezza, capacità relazionale e gestione dello stress per agire in modo più libero — scegliere e non farsi scegliere.',
    icon: <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
    delay: '0ms',
  },
  {
    title: 'Seduta di Ipnosi',
    price: '€80 · 45 min',
    text: "Uno stato di coscienza naturale dove l'attenzione si ritrae dal mondo esterno per ascoltare processi mentali, emotivi e corporei. Nel mio approccio ericksoniano nulla è imposto: si accompagna.",
    icon: <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>,
    delay: '120ms',
  },
  {
    title: 'Supervisione',
    price: '€60 · 45 min',
    text: 'Per psicoterapeuti, operatori della salute mentale ed educatori: uno spazio per riflettere sul proprio lavoro, riconoscere il guaritore ferito e prendersi cura di sé nel proprio percorso clinico.',
    icon: <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>,
    delay: '240ms',
  },
  // TODO cliente (attivi da gennaio/febbraio): confermare PREZZO/durata e i testi definitivi
  // dei due servizi qui sotto — descrizioni attuali sono bozze da rivedere.
  {
    title: 'Terapia di Coppia',
    price: 'Prezzo da definire',
    text: 'Uno spazio condiviso per la coppia: dare voce a incomprensioni, ferite e desideri, ritrovare l’ascolto reciproco e ricostruire un dialogo autentico dove ciascuno possa sentirsi riconosciuto.',
    icon: <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" /></svg>,
    delay: '360ms',
  },
  {
    title: 'Consulenza Sessuologica',
    price: 'Prezzo da definire',
    text: 'Attenzione dedicata alla sfera sessuale e ai vissuti legati all’intimità, affrontati con delicatezza e rispetto: uno spazio sicuro per esplorare difficoltà, blocchi e desideri senza giudizio.',
    icon: <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" /></svg>,
    delay: '480ms',
  },
];

export default function Servizi() {
  const { preselectService } = useApp();

  const handlePrenota = (s: string) => {
    preselectService(s);
    setTimeout(() => {
      document.getElementById('prenota')?.scrollIntoView({ behavior: 'smooth' });
    }, 40);
  };

  return (
    <section id="servizi" className="relative py-28 bg-beigeBG overflow-hidden">
      <div
        className="absolute -left-16 sm:-left-32 top-40 w-[300px] h-[300px] md:w-[380px] md:h-[380px] rounded-full bg-sageLight/40 blur-3xl pointer-events-none"
        data-parallax="0.08"
        style={{ transform: 'translateY(var(--py, 0))' }}
        aria-hidden
      />
      <div
        className="absolute -right-20 sm:-right-40 top-[55%] w-[280px] h-[280px] md:w-[420px] md:h-[420px] rounded-full bg-clay/10 blur-3xl pointer-events-none"
        data-parallax="0.05"
        style={{ transform: 'translateY(var(--py, 0))' }}
        aria-hidden
      />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-4 reveal">
            <div className="flex items-baseline gap-4">
              <span className="font-serif text-5xl italic text-sage/70 leading-none">02</span>
              <span className="text-xs uppercase tracking-[0.3em] text-clay font-semibold">Servizi</span>
            </div>
          </div>
          <div className="lg:col-span-8 space-y-6">
            <h2 className="reveal font-serif text-4xl md:text-5xl text-forestDark leading-[1.1] tracking-tight" style={{ ['--d' as any]: '80ms' }}>
              Cinque spazi distinti, <em className="italic font-light text-sage">un'unica cura</em>.
            </h2>
            <p className="reveal text-charcoal/75 text-sm leading-relaxed max-w-xl" style={{ ['--d' as any]: '160ms' }}>
              Sedute di 45 minuti, online su Google Meet (o WhatsApp Video se necessario). Il primo colloquio è gratuito.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              className="reveal service-card group relative bg-cream p-8 rounded-3xl border border-forest/5 flex flex-col gap-6 shadow-sm hover:shadow-xl smooth-transition hover:-translate-y-1.5"
              style={{ ['--d' as any]: s.delay }}
            >
              <div className="bg-sageLight p-4 rounded-2xl text-forest w-fit service-icon smooth-transition">
                {s.icon}
              </div>
              <div className="space-y-4 flex-1 flex flex-col">
                <div className="space-y-2">
                  <h3 className="font-serif text-2xl text-forestDark font-semibold">{s.title}</h3>
                  <span className="inline-block text-[11px] font-semibold uppercase tracking-wider text-forest/80 border-b border-forest/15 pb-0.5">{s.price}</span>
                </div>
                <p className="text-sm text-charcoal/80 leading-relaxed flex-1">{s.text}</p>
                <button
                  onClick={() => handlePrenota(s.title)}
                  className="link-arrow inline-flex items-center space-x-2 text-xs uppercase font-bold tracking-widest text-clay hover:text-clayDark smooth-transition pt-2"
                >
                  <span>Prenota</span>
                  <span className="arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="reveal mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 p-6 sm:p-7 rounded-2xl bg-cream border border-forest/10">
          <div className="w-11 h-11 rounded-full bg-sage/15 text-forest flex items-center justify-center shrink-0">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M5 13l4 4L19 7" /></svg>
          </div>
          <div className="flex-1 space-y-1">
            <p className="font-serif text-lg text-forestDark">Il primo colloquio è gratuito.</p>
            <p className="text-xs text-charcoal/70 leading-relaxed">Uno spazio per conoscerci, chiarire dubbi e valutare insieme se iniziare un percorso. Pagamento a fine mese tramite bonifico, con fattura sanitaria detraibile.</p>
          </div>
          <a href="#prenota" className="self-start sm:self-auto text-xs uppercase tracking-widest font-bold text-clay border border-clay/40 hover:border-clay hover:bg-clay/5 px-5 py-2.5 rounded-full smooth-transition whitespace-nowrap">
            Prenota ora
          </a>
        </div>
      </div>
    </section>
  );
}
